import React, { useState } from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const PRODUCT_TYPES = [
  { key: "mum", label: "Kişiye Özel Mum" },
  { key: "sabun", label: "Kişiye Özel Sabun" },
  { key: "set", label: "Kişiye Özel Hediye Seti" },
];

export default function CustomOrder() {
  const [form, setForm] = useState({
    customer_name: "", phone: "", email: "",
    product_type: "mum", quantity: 1,
    scent: "", color: "", label_text: "", gift_note: "", reference_url: "", notes: "",
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handle = (k) => (e) => setForm({ ...form, [k]: k === "quantity" ? Math.max(1, +e.target.value || 1) : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/custom-orders", form);
      setDone(true);
    } catch (err) {
      toast.error(formatErr(err));
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="custom-success">
        <CheckCircle2 size={56} className="mx-auto text-larc-gold" />
        <h1 className="font-heading text-5xl mt-6">Talebiniz alındı</h1>
        <p className="text-larc-muted mt-4 max-w-md mx-auto">Atölyemiz en kısa sürede sizinle iletişime geçecek. Sevgili emeklerimiz şimdi sizinle buluşmaya hazırlanıyor.</p>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 py-16" data-testid="custom-order-page">
      <div className="text-center max-w-2xl mx-auto">
        <div className="text-xs tracking-[0.25em] uppercase text-larc-gold">— Atölyemiz</div>
        <h1 className="font-heading text-5xl md:text-6xl tracking-tight mt-3">Kişiye Özel Üretim</h1>
        <p className="text-larc-muted mt-4">Kokusunu, rengini, etiketini birlikte tasarlayalım. Sevdikleriniz için unutulmaz bir hediye olalım.</p>
      </div>

      <form onSubmit={submit} className="mt-14 grid md:grid-cols-2 gap-x-10 gap-y-6 bg-white border border-larc-border rounded-3xl p-8 md:p-12">
        <div className="md:col-span-2 text-xs uppercase tracking-[0.18em] text-larc-gold">— İletişim</div>
        <Field label="Ad Soyad" required value={form.customer_name} onChange={handle("customer_name")} testid="custom-name" />
        <Field label="Telefon" required value={form.phone} onChange={handle("phone")} testid="custom-phone" />
        <Field label="E-posta" type="email" value={form.email} onChange={handle("email")} testid="custom-email" />

        <div className="md:col-span-2 text-xs uppercase tracking-[0.18em] text-larc-gold mt-4">— Sipariş Detayları</div>
        <label className="block">
          <span className="text-xs uppercase tracking-[0.15em] text-larc-muted">Ürün Tipi *</span>
          <select required value={form.product_type} onChange={handle("product_type")} className="mt-2 w-full bg-white border border-larc-border rounded-lg px-4 py-3 outline-none focus:border-larc-gold text-sm" data-testid="custom-type">
            {PRODUCT_TYPES.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
          </select>
        </label>
        <Field label="Adet" required type="number" value={form.quantity} onChange={handle("quantity")} testid="custom-quantity" />
        <Field label="Koku" value={form.scent} onChange={handle("scent")} testid="custom-scent" placeholder="ör. lavanta, vanilya" />
        <Field label="Renk" value={form.color} onChange={handle("color")} testid="custom-color" placeholder="ör. krem, soft pembe" />
        <Field label="Etiket Yazısı" value={form.label_text} onChange={handle("label_text")} testid="custom-label" placeholder="ör. Elif & Mehmet" />
        <Field label="Hediye Notu" value={form.gift_note} onChange={handle("gift_note")} testid="custom-gift" placeholder="kart için kısa not" />
        <Field label="Referans Görsel URL" value={form.reference_url} onChange={handle("reference_url")} testid="custom-ref" placeholder="https://..." />
        <Field label="Notlar" value={form.notes} onChange={handle("notes")} testid="custom-notes" textarea />

        <div className="md:col-span-2 mt-4">
          <button type="submit" disabled={loading} className="inline-flex items-center justify-center gap-2 bg-larc-ink text-white rounded-full px-10 py-3.5 text-sm hover:bg-larc-gold transition-colors disabled:opacity-50 active:scale-95" data-testid="submit-custom">
            {loading ? "Gönderiliyor…" : "Talebi Gönder"} <ArrowRight size={16} />
          </button>
        </div>
      </form>
    </div>
  );
}

function Field({ label, required, type = "text", value, onChange, testid, textarea, placeholder }) {
  return (
    <label className="block">
      <span className="text-xs uppercase tracking-[0.15em] text-larc-muted">{label}{required && " *"}</span>
      {textarea ? (
        <textarea required={required} value={value} onChange={onChange} rows={3} placeholder={placeholder} className="mt-2 w-full bg-white border border-larc-border rounded-lg px-4 py-3 outline-none focus:border-larc-gold text-sm" data-testid={testid} />
      ) : (
        <input required={required} type={type} value={value} onChange={onChange} placeholder={placeholder} className="mt-2 w-full bg-white border border-larc-border rounded-lg px-4 py-3 outline-none focus:border-larc-gold text-sm" data-testid={testid} />
      )}
    </label>
  );
}
